<template>
  <div>
    <Header>Дата и время</Header>
    <div class="container">
      <div class="row wrapper">
        <section class="col-xl-12 col-12 wrapper-blue">
          <!-- DATE AND TIME -->
          <section class="calendar">
            <div class="days-slider">
              <div class="day prev" v-on:click="prevDate($event)">
                <span class="month">--</span><br>
                <span class="day--number">--</span><br>
                <span class="dat--name">--</span>
              </div>
              <div class="day active" data-current="">
                <span class="month">--</span><br>
                <span class="day--number">--</span><br>
                <span class="dat--name">--</span>
              </div>
              <div class="day next" v-on:click="nextDate($event)">
                <span class="month">--</span><br>
                <span class="day--number">--</span><br>
                <span class="dat--name">--</span>
              </div>
            </div>
          </section>
        </section>
        <section
          v-if="available.length > 0"
          class="col-xl-12 col-12 wrapper-white datetime-table">
          <div
            class="hours"
            v-for="(period, index) in available"
            v-bind:key="'datetime-' + String(index)">
            <div class="hours--morning" v-if="getParst(period.start, period.end).length > 0">
              <div class="hours-wrapper"
                   v-for="(chunk, j) in getParst(period.start, period.end)"
                   v-bind:key="'time-' + String(j)">
                <div class="hour"
                     v-on:click="getTime($event, setTime(time))"
                     v-for="(time, k) in chunk"
                     v-bind:key="'hour-' + String(k)"
                     :data-active="isTimeActive(time)"
                     :data-time="time"
                     :data-datetime="setTime(time)"
                     v-text="time"></div>
              </div>
            </div>
          </div>
          <section class="col-xl-12 col-12 wrapper-gray">
            <section class="buttons top-done">
              <router-link to="/"><button class="btn button-blue">OK</button></router-link>
            </section>
          </section>
        </section>
        <section
          v-if="available.length === 0"
          class="col-xl-12 col-12 wrapper-white datetime-table"
          style="text-align: center; padding: 1rem; background: #f6f7fb;">
          <p style="margin-top: 1rem;">На этот день запись недоступна</p>
        </section>
      </div>
    </div>
  </div>
</template>

<style>
.buttons {
  display: none;
  margin-top: 2rem;
}

.button-blue {
  padding: 1rem 0px;
  width: 100%;
  text-align: center;
  background: #2F80ED;
  backdrop-filter: blur(81.6395px);
  border: none;
  border-radius: 36px;
  color: #fff;
  margin-bottom: 1rem;
}

.button-blue:active {
  background: #ff9500;
  color: #fff;
}

.hour:active {
  background: #2F80ED;
  color: #fff;
}

.hour.active {
  background: #2F80ED;
  color: #fff;
}

.datetime-table {
  padding: 0px !important;
}

.hours--morning {
  padding: 1rem;
}

.datetime .top h2 {
  font-size: 16px !important;
}

.hour[data-active="true"] {
  background: #2F80ED !important;
  color: #fff !important;
}
</style>

<script>
import Header from '../components/header.vue';
import moment from 'moment';
import _ from 'underscore';
import axios from 'axios';

export default {
  name: 'Datetime',
  data() {
      return {
        todayDate: null,
        time: null,
        available: {},
        booked: {},
        reserved: {},
        currentIndex: 0,
        workTime: {},
        daysCount: 365,
      };
  },
  metaInfo: {
      title: 'Дата и время',
      titleTemplate: '%s - Онлайн-запись MyClient',
      htmlAttrs: {
          lang: 'ru',
          amp: false
      }
  },
  mounted: function() {
    /**
     * Render calendar slider
     */
    const currentDay = moment().utcOffset(0).format('YYYY-MM-DD');

    if (window.professionalId) {
      this.loadWorkTime(window.professionalId, currentDay, this.daysCount);
    } else {
      axios.get(`/api/bookings/${window.bookingId}/details`).then((response) => {
        if (response.data && response.data.status === 'success') {
          window.professionalId = response.data.data.professional.id;
          this.loadWorkTime(window.professionalId, currentDay, this.daysCount);
        } else {
          this.$router.push('/form');
        }
      }).catch(() => {
        this.$router.push('/form');
      });
    }

    /**
     * Events
     */
    $('[data-active="true"]').addClass('active');
  },
  beforeCreate: function() {
    document.body.className = 'datetime';
  },
  methods: {
      getTime: function(event, currentDatetime) {
        let vm = this;
        let hasActive = $(event.currentTarget).hasClass('active');
        $('.hour').removeClass('active');
        if(!hasActive) {
          $(event.currentTarget).addClass('active');
          $(event.currentTarget).data('active', 'false');

          vm.$store.dispatch('hour', $(event.currentTarget).data('time'));
          vm.$store.dispatch('date', moment(vm.todayDate).format('YYYY-MM-DD'));
          vm.$store.dispatch('datetime', moment(
            moment(vm.todayDate).format('YYYY-MM-DD') + ' ' + $(event.currentTarget).data('time')
          ).format('YYYY-MM-DDTHH:mm:ss'));
        } else {
          vm.$store.dispatch('hour', '');
          vm.$store.dispatch('date', '');
          vm.$store.dispatch('datetime', '');
        }

        vm.showHideDone();
      },
      getDateByString: function(date) {
        return Date.parse(date);
      },
      timeSort: function(times) {
        let self = this;

        return times.sort(function(value1, value2) {
          return self.getDateByString(value1.date) < self.getDateByString(value2.date) ? -1 : 1;
        });
      },
      getParst: function(startAt, endAt, chunk = true) {
        let vm = this,
            timezoneOffset = Math.abs((new Date).getTimezoneOffset()) * 60;
        startAt = this.timestrToSec(startAt) + timezoneOffset;
        endAt = this.timestrToSec(endAt) + timezoneOffset;

        let part = startAt;
        let parts = [];

        while (part <= endAt - this.servicesDuration) {
          parts.push(this.formatTime(part));
          part += this.timestrToSec('00:15');
        }

        if (chunk === true) {
          return _.chunk(parts, 3);
        }

        return parts;
      },
      haveTimeInDiapason(diap, time) {
        for (let j in diap) {
          let dTime = diap[j];
          let startTime = this.timestrToSec(dTime.start) + Math.abs((new Date).getTimezoneOffset()) * 60;
          let endTIme = this.timestrToSec(dTime.end) + Math.abs((new Date).getTimezoneOffset()) * 60;

          if((time > startTime  && time < endTIme)) {
            return true;
          }
        }

        return false;
      },
      prevDate: function(event) {
        let vm = this;
        let index = vm.currentIndex;

        if(typeof this.workTime[index - 1] !== 'undefined') {
          vm.currentIndex = index - 1;

          let time =  this.workTime[index - 1];
          let date = time.date;

          vm.available = time.time.available;
          vm.booked = time.time.booked;
          vm.reserved = time.time.reserved;
          vm.todayDate = date;

          const currentDate = new Date(this.workTime[index - 1].date);
          this.changeCurrentDate(currentDate);

          if(typeof this.workTime[index - 2] !== 'undefined') {
            const prevDate = new Date(this.workTime[index - 2].date);
            this.changePrevDate(prevDate);
          } else {
            $('.prev').find('.month').text('--');
            $('.prev').find('.day--number').text('--');
            $('.prev').find('.dat--name').text('--');
          }

          if(typeof this.workTime[index] !== 'undefined') {
            const nextDate = new Date(this.workTime[index].date);
            this.changeNextDate(nextDate);
          }
        } else {
          $('.prev').find('.month').text('--');
          $('.prev').find('.day--number').text('--');
          $('.prev').find('.dat--name').text('--');
        }
      },
      nextDate: function(event) {
        let vm = this;
        let index = vm.currentIndex;

        if (typeof this.workTime[index + 1] !== 'undefined') {
          vm.currentIndex = index + 1;

          let time =  this.workTime[index + 1];
          let date = time.date;

          vm.available = time.time.available;
          vm.booked = time.time.booked;
          vm.reserved = time.time.reserved;
          vm.todayDate = date;

          const currentDate = new Date(this.workTime[index + 1].date);
          this.changeCurrentDate(currentDate);

          if(typeof this.workTime[index + 2] !== 'undefined') {
            const nextDate = new Date(this.workTime[index + 2].date);
            this.changeNextDate(nextDate);
          } else {
            $('.next').find('.month').text('--');
            $('.next').find('.day--number').text('--');
            $('.next').find('.dat--name').text('--');
          }

          if(typeof this.workTime[index] !== 'undefined') {
            const prevDate = new Date(this.workTime[index].date);
            this.changePrevDate(prevDate);
          }
        } else {
          $('.next').find('.month').text('--');
          $('.next').find('.day--number').text('--');
          $('.next').find('.dat--name').text('--');
        }
      },
      isTimeActive: function(currentTime) {
        let result = currentTime === this.hour && this.date === moment(
          $('.days-slider').find('.active').data('current')
        ).format('YYYY-MM-DD')
          ? 'true' : 'false';

        if(result === 'true') {
          $('.top-done').show();
        }

        return result;
      },
      changeCurrentDate(DateObj) {
        this.changeDate('.active', DateObj);
      },
      changePrevDate(DateObj) {
        this.changeDate('.prev', DateObj);
      },
      changeNextDate(DateObj) {
        this.changeDate('.next', DateObj);
      },
      changeDate(selector, DateObj) {
        let daysSlider = $('.days-slider').find(selector);

        daysSlider.data('current', DateObj);
        daysSlider.find('.day--number').text(DateObj.getUTCDate());
        daysSlider.find('.dat--name').text(this.days[DateObj.getDay()]);
        daysSlider.find('.month').text(this.months[DateObj.getMonth()]);
      },
      showHideDone() {
        if(this.hour !== '') {
          $('.top-done').show();
        } else {
          $('.top-done').hide();
        }
      },
      parseTimeToMinutes(time) {
        time = String(time);
        time = time.replace(':', '');

        return Number(time);
      },
      getTimeFromMins(mins) {
        let num = mins;
        let hours = (num / 60);
        let rhours = Math.floor(hours);
        let minutes = (hours - rhours) * 60;
        let rminutes = Math.round(minutes);

        return (rhours < 10 ? '0' : '' ) + rhours + ":" + rminutes;
      },
      timestrToSec(timestr) {
        var parts = timestr.split(":");
        return (parts[0] * 3600) +
              (parts[1] * 60);
      },
      pad(num) {
        if(num < 10) {
          return "0" + num;
        } else {
          return "" + num;
        }
      },
      formatTime(seconds) {
        return [this.pad(Math.floor(seconds/3600)),
                this.pad(Math.floor(seconds/60)%60),
                ].join(":");
      },
      setTime(hour) {
        const vm = this;
        const today = vm.date !== '' ? new Date(vm.date) : vm.todayDate;

        let hourExplode = String(hour).match (/^(\d+):/);
        let periodExplode = String(hour).match (/:(\d+)$/);

        let date = new Date(today);

        date.setHours(Number(hourExplode[1]));
        date.setMinutes(Number(periodExplode[1]));
        date.setSeconds('0');

        return date;
      },
      loadWorkTime(professionalId, startDate = null, count = 30) {
        let vm = this;
        this.servicesDuration = this.timestrToSec(this.hours);

        axios.post(`/api/professional/${professionalId}/schedule/breakdown`, {
          count: count,
          startDate: startDate
        }).then((response) => {
            let data = response.data;
            let days = this.prepareDates(data.data.days);
            vm.workTime = days;

            for(let index in days) {
              index = Number(index);
              vm.currentIndex = index;

              if(typeof days[index] !== 'undefined') {
                let time =  days[index];
                let date = time.date;

                vm.available = time.time.available;
                vm.booked = time.time.booked;
                vm.reserved = time.time.reserved;

                vm.currentIndex = index;
                vm.todayDate = new Date(vm.getDateByString(date));
                vm.changeCurrentDate(vm.todayDate);

                if(typeof days[index + 1] !== 'undefined') {
                  const nextDate = new Date(days[index + 1].date);
                  vm.changeNextDate(nextDate);
                }

                if(typeof days[index - 1] !== 'undefined') {
                  const prevDate = new Date(days[index - 1].date);
                  vm.changePrevDate(prevDate);
                }
              }

              break;
            }
          }).catch((error) => {
            console.log(error);
          });
      },
      prepareDates(days) {
        let time = [];

        for(let jKey in days) {
          time.push({
            'date': jKey,
            'time': days[jKey],
          });
        }

        return this.timeSort(time);
      }
  },
  components: {
    Header
  },
  computed: {
    date() {
      return this.$store.getters.date;
    },
    hour() {
      return this.$store.getters.hour;
    },
    datetime() {
      return this.$store.getters.datetime;
    },
    days() {
      return this.$store.getters.days;
    },
    months() {
      return this.$store.getters.months;
    },
    hours() {
      return this.$store.getters.hours;
    }
    /*workTime() {
      let time = [];

      for(let jKey in this.$store.getters.workTime) {
        time.push({
          'date': jKey,
          'time': this.$store.getters.workTime[jKey],
        });
      }

      return this.timeSort(time);
    }*/
  },
};
</script>
